import { apiLdap } from '@spo/services/api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const useTeamMembers = (memberIds: string[]) => {
  return useQuery({
    queryKey: ['useTeamMembers', memberIds],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = apiLdap.getUsersByIds(memberIds);
        return response;
      }
    },
    placeholderData: keepPreviousData,
    enabled: memberIds.length > 0,
  });
};
